import { Box, Button, Group, Stack, Text } from "@mantine/core";
import type { IFormValues } from "../AiPersonalityForm";
import classes from "./CheckpointsList.module.css";

export type ICheckpoint = {
    id: string;
    createdAt: number;
    values: IFormValues;
    testScore?: number | null;
    source: "manual" | "form-test";
};

interface Props {
    checkpoints: ICheckpoint[];
    onSaveCheckpoint: () => void;
    onRestore: (cp: ICheckpoint) => void;
}

function formatDate(ts: number) {
    const d = new Date(ts);
    return d.toLocaleString();
}

function formatScore(score: number | null | undefined) {
    if (score === undefined) {
        return "";
    }
    if (score === null) {
        return "N/A";
    }
    return score.toFixed(3);
}

export default function CheckpointsList({ checkpoints, onSaveCheckpoint, onRestore }: Props) {
    return (
        <Box>
            <Group justify="space-between" mb="xs">
                <Text fw={600}>Checkpoints</Text>
                <Button size="xs" variant="light" onClick={onSaveCheckpoint}>
                    Save checkpoint
                </Button>
            </Group>
            {checkpoints.length === 0 ? (
                <Text c="dimmed" size="sm">
                    No checkpoints yet. Use "Save checkpoint" or run a Test to create one.
                </Text>
            ) : (
                <Stack gap={8} className={classes.list}>
                    {checkpoints.map((cp) => (
                        <Button
                            key={cp.id}
                            size="compact-sm"
                            variant="light"
                            color="blue"
                            radius="md"
                            className={classes.itemButton}
                            onClick={() => onRestore(cp)}
                        >
                            <Group justify="space-between" w="100%">
                                <Text size="sm" fw={500}>
                                    {formatDate(cp.createdAt)}
                                </Text>
                                <Text size="sm">
                                    {cp.testScore !== undefined && <>Score: {formatScore(cp.testScore)}</>}
                                </Text>
                            </Group>
                        </Button>
                    ))}
                </Stack>
            )}
        </Box>
    );
}
